import { render } from "./TvmKbbTradeValue.vue?vue&type=template&id=27db609a&scoped=true"
import script from "./TvmKbbTradeValue.vue?vue&type=script&lang=js"
export * from "./TvmKbbTradeValue.vue?vue&type=script&lang=js"

import "./TvmKbbTradeValue.vue?vue&type=style&index=0&id=27db609a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27db609a"],['__file',"src/Components/ChatWidget/TvmSellUsYourCar/TvmKbbTradeValue.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27db609a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27db609a', __exports__)) {
    api.reload('27db609a', __exports__)
  }
  
  module.hot.accept("./TvmKbbTradeValue.vue?vue&type=template&id=27db609a&scoped=true", () => {
    api.rerender('27db609a', render)
  })

}


export default __exports__